import React, { createContext, useCallback, useMemo } from "react";

export interface AutoScrollContext {
  scrollToBottom: () => void;
}

export const AutoScrollContext = createContext<AutoScrollContext>({
  scrollToBottom: () => undefined,
});

interface AutoScrollProviderProps<T> {
  target: React.RefObject<T>;
}

export const AutoScrollProvider: React.FC<
  React.PropsWithChildren<AutoScrollProviderProps<HTMLElement>>
> = ({ target, children }) => {
  const scrollToBottom = useCallback(() => {
    requestAnimationFrame(() => {
      const el = target.current;
      if (!el) return;

      const { scrollTop, scrollHeight, clientHeight } = el;
      const hiddenHeight = scrollHeight - clientHeight;
      if (hiddenHeight === scrollTop) return;

      el.scrollTo({ top: hiddenHeight });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const context = useMemo(() => ({ scrollToBottom }), [scrollToBottom]);

  return (
    <AutoScrollContext.Provider value={context}>
      {children}
    </AutoScrollContext.Provider>
  );
};
